import { render, staticRenderFns } from "./ArticleSkeletonLoader.vue?vue&type=template&id=5fdcbfde&scoped=true"
import script from "./ArticleSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./ArticleSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSkeletonLoader.vue?vue&type=style&index=0&id=5fdcbfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcbfde",
  null
  
)

export default component.exports